var ratio = 16 / 9;
var containerWidth = 800;
var containerHeight = containerWidth * 1 / ratio;

var leftPaneWidth = 75;
var rightPaneWidth = 25;

var floorplanWidth = containerWidth * leftPaneWidth / 100 - 33 * 2; // 534

// ----------------------------------------------------------------------------------------------------------
export const livefeedStyle = {
    ratio: ratio,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    leftPaneWidth: leftPaneWidth,
    rightPaneWidth: rightPaneWidth,
    floorplanWidth: floorplanWidth,
    floorplanStyle: {
        // FLOORPLAN PREVIEW (Used for snapping)
        // Convert 80px to 33px from 1920x1080 to 800x450
        // All are converted into top-left coordinates
        // For styling floorplan
        top: `${containerHeight * 0.28}px`,
        bottom: `33px`,
        left: `33px`,
        right: `33px`
    },
    // Entity style, use for aligning
    align: {
        top: containerHeight * 0.28,
        bottom: containerHeight - 33,
        left: 33,
        right: containerWidth * leftPaneWidth / 100 - 33,
        center: 33 + (containerWidth * leftPaneWidth / 100 - 33 * 2) / 2,
        summaryCenter: 33 + (containerWidth * (leftPaneWidth + rightPaneWidth) / 100 - 33 * 2) / 2,
        summaryRight: containerWidth * (leftPaneWidth + rightPaneWidth) / 100 - 33
    }
}
// ----------------------------------------------------------------------------------------------------------
const defaultEditorState = {
    colorPickerPos: { x: 0, y: 0 },
    mapConfigMode: "user_input",
    slideCurrentIndex: 0, // editor slide changes handle
    editorView: true, // editor view handle
    stepNumberState: 0, // use for manipulate redo undo
    // below property will be received from backend || or send to backend
    containerWidth: containerWidth,// use for display livefeed with correct ratio
    containerHeight: containerHeight, // use for display livefeed with correct ratio
    livefeedName: "Livefeed Name",
    livefeedSlides: [
        {
            slideType: 'summary',
            floorplanOptions: {
                locationsID: [],
                duration: 5,
                widgetLabelType: true, //false means display one value only 50, if true, 50/100
                sensorFilterType: "occupied-unOccupied", // occupied or occupied-unOccupied,
                isStandbyAsUnOccupied: false // treat standby sensors as UnOccupied sensor
            },
            historyEntities: [{ id: null }],
            fontFamily: "GTWalsheimProRegular",
            logoState: {
                slideCurrentIndex: 0,
                id: "logo",
                width: 125,
                top: 15,
                left: 33,
                align: "left",
                url: null,
                show: true,
                activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
            },
            lineState: {
                id: "line",
                slideCurrentIndex: 0,
                show: true,
                color: "#4a4a4a",
                thickness: 2,
                length: 734,
                top: 42,
                left: 33,
                align: "left",
                activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
            },
            textContainer: [
                {
                    slideCurrentIndex: 0,
                    align: "left",
                    width: 83,
                    height: 36,
                    color: "#4a4a4a",
                    content: "Text box",
                    left: 33,
                    size: 20,
                    top: 55,
                    show: true,
                    textStyle: {},
                    activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: true, bold: false, italic: false, underline: false }]
                }
            ],
            slideBg: {
                slideCurrentIndex: 0,
                id: "slideBg",
                color: "#ffffff",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            }, // only on summary page
            gauge0: {
                slideCurrentIndex: 0,
                id: "gauge0",
                width: 190,
                top: 160,
                left: 33,
                label: "Available Desks",
                align: "left",
                activeToolbarItems: [{ align: "left" }, { deletable: false }, { isText: false }]
            },// only on summary page
            gauge1: {
                slideCurrentIndex: 0,
                id: "gauge1",
                width: 190,
                top: 160,
                left: 305,
                label: "Available Open Area Rooms",
                align: "center",
                activeToolbarItems: [{ align: "center" }, { deletable: false }, { isText: false }]
            },// only on summary page
            gauge2: {
                slideCurrentIndex: 0,
                id: "gauge2",
                width: 190,
                top: 160,
                left: 577,
                label: "Available Meeting Rooms",
                align: "right",
                activeToolbarItems: [{ align: "right" }, { deletable: false }, { isText: false }]
            },// only on summary page
            rightPanelTextTitle: {
                id: "rightPanelTextTitle",
                slideCurrentIndex: 0,
                size: 17,
                contents: ["Available desks", "Available meeting rooms"],
                align: "center",
                color: "#000000",
                textStyle: {},
                activeToolbarItems: [{ align: "center" }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
            },
            rightPanelGaugeValueLabel: {
                id: "rightPanelGaugeValueLabel",
                slideCurrentIndex: 0,
                size: 28,
                align: "center",
                color: "#000000",
                textStyle: {},
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
            },
            rightPanelGaugeOccupiedBg: {
                id: "rightPanelGaugeOccupiedBg",
                slideCurrentIndex: 0,
                color: "#3cb449",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            },
            rightPanelGaugeOffsetdBg: {
                id: "rightPanelGaugeOffsetdBg",
                slideCurrentIndex: 0,
                color: "#EEEEEE",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            },
            rightPanelGaugeNeedle: {
                id: "rightPanelGaugeNeedle",
                slideCurrentIndex: 0,
                color: "#EEEEEE",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            }
        },
        {
            slideType: 'locationsList',
            floorplanOptions: {
                duration: 5
            },
            historyEntities: [{ id: null }],
            fontFamily: "GTWalsheimProRegular",
            logoState: {
                slideCurrentIndex: 1,
                id: "logo",
                width: 125,
                top: 15,
                left: 33,
                align: "left",
                url: null,
                show: true,
                activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
            },
            lineState: {
                id: "line",
                slideCurrentIndex: 1,
                show: true,
                color: "#4a4a4a",
                thickness: 2,
                length: 734,
                top: 42,
                left: 33,
                align: "left",
                activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
            },
            textContainer: [
                {
                    slideCurrentIndex: 1,
                    align: "left",
                    width: 303,
                    height: 36,
                    color: "#4a4a4a",
                    content: "Locations chosen on this livefeed",
                    left: 33,
                    size: 20,
                    top: 55,
                    show: true,
                    textStyle: {},
                    activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: true, bold: false, italic: false, underline: false }]
                }
            ],
            slideBg: {
                slideCurrentIndex: 1,
                id: "slideBg",
                color: "#ffffff",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            },
            locationsListStyle: {
                slideCurrentIndex: 1,
                id: "locationsListStyle",
                color: "#000000",
                left: 33,
                size: 22,
                width: 734,
                top: 100,
                locationCol: 4,
                textStyle: {},
                activeToolbarItems: [{ align: "left" }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
            }
        },
        {
            slideType: 'slideshow',
            floorplanOptions: {
                locationsID: [],
                duration: 5,
                lockScroll: false,
                widgetLabelType: true, //false means display one value only 50, if true, 50/100
                sensorFilterType: "occupied-unOccupied", // occupied or occupied-unOccupied,
                isStandbyAsUnOccupied: false, // treat standby sensors as UnOccupied sensor,
                liveApiKey: "",
                mapApiKey: "",
                mapConfig: {
                    container: 'mapboxMap',
                    center: [0, 0], // [24.8123896, 60.2209478],
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    hash: false,
                    attributionControl: false,
                    bearingSnap: 0,
                    aniDuration: 2,
                    use3dMap: true,
                    animationType: { value: "flyTo", label: "flyTo" }
                }
            },
            historyEntities: [{ id: null }],
            fontFamily: "GTWalsheimProRegular",
            logoState: {
                slideCurrentIndex: 2,
                id: "logo",
                width: 125,
                top: 15,
                left: 33,
                align: "left",
                url: null,
                show: true,
                activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
            },
            lineState: {
                id: "line",
                slideCurrentIndex: 2,
                show: true,
                color: "#4a4a4a",
                thickness: 2,
                length: livefeedStyle.floorplanWidth,
                top: 42,
                left: 33,
                align: "left",
                activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: false }]
            },
            textContainer: [
                {
                    slideCurrentIndex: 2,
                    align: "left",
                    width: 83,
                    height: 36,
                    color: "#4a4a4a",
                    content: "Text box",
                    left: 33,
                    size: 20,
                    top: 55,
                    show: true,
                    textStyle: {},
                    activeToolbarItems: [{ align: "left" }, { deletable: true }, { isText: true, bold: false, italic: false, underline: false }]
                }
            ],
            leftPanelBg: {
                slideCurrentIndex: 2,
                id: "leftPanelBg",
                color: "#ffffff",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            },
            rightPanelBg: {
                slideCurrentIndex: 2,
                id: "rightPanelBg",
                color: "#3f5043",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            },
            rightPanelTextTitle: {
                id: "rightPanelTextTitle",
                slideCurrentIndex: 2,
                size: 17,
                contents: ["Available desks", "Available meeting rooms"],
                align: "center",
                color: "#ffffff",
                textStyle: {},
                activeToolbarItems: [{ align: "center" }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
            },
            rightPanelGaugeValueLabel: {
                id: "rightPanelGaugeValueLabel",
                slideCurrentIndex: 2,
                size: 28,
                align: "center",
                color: "#ffffff",
                textStyle: {},
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: true, bold: false, italic: false, underline: false }]
            },
            rightPanelGaugeOccupiedBg: {
                id: "rightPanelGaugeOccupiedBg",
                slideCurrentIndex: 2,
                color: "#3cb449",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            },
            rightPanelGaugeOffsetdBg: {
                id: "rightPanelGaugeOffsetdBg",
                slideCurrentIndex: 2,
                color: "#EEEEEE",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            },
            rightPanelGaugeNeedle: {
                id: "rightPanelGaugeNeedle",
                slideCurrentIndex: 2,
                color: "#EEEEEE",
                activeToolbarItems: [{ align: null }, { deletable: false }, { isText: false }]
            }
        }
    ]
}
export default defaultEditorState


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/defaultstate.js